import React from 'react';
import styled, { css } from 'styled-components';

export type Props = {};

const AppSectionHeader: React.FCC<Props> = ({ dataTestId, ...rest }) => (
  <Container data-testid={dataTestId} {...rest} />
);

const Container = styled.h2<{}>(
  ({ theme }) => css`
    font-size: 18px;
    color: ${theme.color('text')};
  `,
);

export default AppSectionHeader;
